








export default {
  props: {
    guideRef: String,
  },
};
